import { StyleSheet } from 'aphrodite';
import { hexToRgbA } from 'utils/styleUtil';
import typography from 'defaults/typography';

const getSkin = (theme) => {
    const globalProfiles = theme.globalProfiles;
	const skin = globalProfiles.palette;
	const myTypography = typography(theme);

    return StyleSheet.create({
		title:{
			fontFamily: "Nunito",
			fontStyle: "normal",
			fontWeight: "600",
			fontSize: "16px",
			lineHeight: "22px",
			color: "#000000",
		},

		description:{
			fontFamily: "Open Sans",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "12px",
			lineHeight: "17px",
			color: "#000000",
			opacity: "0.8"

		},
		value:{
			fontFamily: "Nunito",
			fontStyle: "normal",
			fontWeight: 600,
			fontSize: "20px",
			lineHeight: "27px",
			color: "#000000"
		},

		circleDesc:{
			fontFamily: "Open Sans",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "14px",
			lineHeight: "19px",
			color: "#000000"
		},

		pieTitle:{
			fontFamily: "Open Sans",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "14px",
			color: skin.black
		},
		pieTitleBAMBA:{
			fontFamily: "Open Sans",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "12px",
			color: skin.black
		},
		pieScore:{
			fontFamily: "Open Sans",
			fontStyle: "normal",
			fontWeight: "600",
			fontSize: "14px",
			lineHeight: "19px",
			color: skin.black
		},
		pieScoreBAMBA:{
			fontFamily: "Open Sans",
			fontStyle: "normal",
			fontWeight: "600",
			fontSize: "12px",
			lineHeight: "16px",
			color: skin.black
		}
	});
}

export default getSkin;